import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import ResponsiveBasicModal from '../../ResponsiveBasicModal';
import imgServiciosEgresados from '../../../assets/images/Conozca su cuenta de correo institucional y su estado el SIE.png';

const LandingImageModal: React.FC = () => {
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        setOpenModal(true);
    }, []);

    return (
        <ResponsiveBasicModal
            open={openModal}
            handleClose={() => setOpenModal(false)}
            fullWidth={true}
            maxWidth="xs"
            paperClassName="landing-image-modal"
        >
            <Grid container justify="center" alignItems="center">
                <Grid item xs={12}>
                    <Link to="/consulta-estado" aria-label="Consultar estado del registro">
                        <img
                            src={imgServiciosEgresados}
                            alt="Consultar estado del registro de egresados"
                            className="landing-modal-image"
                        />
                    </Link>
                </Grid>
            </Grid>
        </ResponsiveBasicModal>
    );
};

export default LandingImageModal;
